import axios from "axios";
import {
  interceptRequest,
  onRequestError,
} from "./interceptors/interceptRequest";
import {
  interceptResponse,
  onResponseError,
} from "./interceptors/interceptResponse";

export const requestSearch = () => {
  const searchRequest = axios.create({
    baseURL: process.env.REACT_APP_SEARCH_API_BASE_URL,
    timeout: 30000,
  });

  searchRequest.interceptors.request.use(interceptRequest, onRequestError);
  searchRequest.interceptors.response.use(interceptResponse, onResponseError);
  return searchRequest;
};
